import React from "react";
import Layout from "../components/Layout";
import Breadcrumbs from "../components/Breadcrumbs";
import PreFooterCTA from "../components/PreFooterCTA";
import { BUSINESS } from "../data/business";

const BREADCRUMBS = [{ label: "Terms of Service" }];

export default function Terms() {
  return (
    <Layout>
      <section className="abc-bg-pale">
        <div className="abc-container py-12 md:py-16 max-w-4xl">
          <Breadcrumbs items={BREADCRUMBS} />
          <h1 className="font-display mt-4 text-3xl sm:text-4xl font-extrabold text-[#1A1D21]">Terms of Service</h1>
          <p className="text-sm text-slate-500 mt-2">Last updated: November 2025</p>

          <div className="mt-8 prose prose-slate max-w-none text-slate-700 leading-relaxed space-y-4">
            <h2 className="font-display text-2xl font-bold text-[#1A1D21]">1. Acceptance of Terms</h2>
            <p>By using the {BUSINESS.name} website, requesting a quote, or scheduling service, you agree to these Terms of Service.</p>

            <h2 className="font-display text-2xl font-bold text-[#1A1D21]">2. Services</h2>
            <p>{BUSINESS.name} provides drain and sewer services across the Baltimore and Temple Hills / DC metros. Quotes are estimates based on the information you provide and may change once a technician inspects the work.</p>

            <h2 className="font-display text-2xl font-bold text-[#1A1D21]">3. SMS / Text Message Consent (A2P 10DLC)</h2>
            <p>By submitting your phone number through a form on this site, you agree to receive transactional and service-related text messages from {BUSINESS.name} related to your inquiry, appointment, or service. Message frequency varies. Message and data rates may apply. Reply <strong>STOP</strong> to opt out at any time. Reply <strong>HELP</strong> for help. We do not share your mobile information with third parties or affiliates for marketing or promotional purposes.</p>

            <h2 className="font-display text-2xl font-bold text-[#1A1D21]">4. Payment &amp; Estimates</h2>
            <p>All work is quoted before it begins. Payment is due upon completion unless otherwise agreed in writing.</p>

            <h2 className="font-display text-2xl font-bold text-[#1A1D21]">5. Warranty</h2>
            <p>Most repairs include a labor warranty. Installations carry the manufacturer warranty in addition to ours. Ask for specifics on your job.</p>

            <h2 className="font-display text-2xl font-bold text-[#1A1D21]">6. Limitation of Liability</h2>
            <p>{BUSINESS.name}'s liability is limited to the cost of the services provided.</p>

            <h2 className="font-display text-2xl font-bold text-[#1A1D21]">7. Changes</h2>
            <p>We may update these Terms from time to time. Continued use of our services means you accept the updated Terms.</p>

            <h2 className="font-display text-2xl font-bold text-[#1A1D21]">8. Contact</h2>
            <p>Questions about these Terms? Email <a href={BUSINESS.emailHref} className="text-[#54616E] underline hover:text-[#1A1D21]">{BUSINESS.email}</a> or call <a href={BUSINESS.phoneHref} className="text-[#54616E] underline hover:text-[#1A1D21]">{BUSINESS.phone}</a>.</p>
          </div>
        </div>
      </section>
      <PreFooterCTA />
    </Layout>
  );
}
